import PropTypes from 'prop-types';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';

import RichText from '../../../Core/RichText';
import Pills from '../../../Core/Pills';
import ProductIconText from '../../Optimum/OptimumProductCards/ProductIconText';
import InterestsValueComponent from '../../../Providers/Core/Services/InterestValue';
import CtaModal from '../../CtaModal';

import {
  Card,
  ImageWrapper,
  Body,
  TextWrapper,
  LegalCopy,
  StyledCtas,
  Heading,
  BodyCopy,
} from './styles';

const title = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <Heading>{children}</Heading>,
  },
};

const body = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <BodyCopy>{children}</BodyCopy>,
    [BLOCKS.EMBEDDED_ENTRY]: node => {
      const { data: segment } = node;
      if (
        segment.target &&
        segment.target.__typename === 'ContentfulTitleOrImageWithIconLists'
      ) {
        return (
          <ProductIconText
            className="no-margin product-image"
            data={segment.target}
          />
        );
      }
      return null;
    },
    [INLINES.EMBEDDED_ENTRY]: node => {
      const { data: segment } = node;
      if (segment.target && segment.target.__typename === 'ContentfulCoreApi') {
        return (
          <InterestsValueComponent
            key={segment.target.id}
            data={segment.target}
          />
        );
      }
      if (segment.target && segment.target.__typename === 'ContentfulModal') {
        return (
          <CtaModal
            as="span"
            className="no-chevron"
            key={segment.target.id}
            data={segment.target}
          />
        );
      }
      return null;
    },
  },
};

const legal = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <LegalCopy>{children}</LegalCopy>,
  },
};

const ProductImageCard = ({ data = null, className = '' }) => {
  if (!data) return null;

  const {
    id,
    textAlignment,
    heading,
    bodyCopy,
    bottomCopy,
    ctas,
    backgroundColor,
    imageDam,
    pillBackgroundColor,
    pillTextColor,
    pillText,
    pillIcon,
  } = data;

  return (
    <Card
      className={className}
      key={id}
      role="listitem"
      $backgroundColor={backgroundColor}
    >
      {imageDam && (
        <ImageWrapper $image={imageDam.asset.localImage.publicURL} />
      )}
      <Body>
        {(heading || bodyCopy || bottomCopy) && (
          <TextWrapper $textAlignment={textAlignment}>
            {pillText && (
              <Pills
                backgroundColor={pillBackgroundColor}
                textColor={pillTextColor}
                pillIcon={pillIcon}
              >
                {pillText}
              </Pills>
            )}
            {heading && <RichText document={heading} options={title} />}
            {bodyCopy && <RichText document={bodyCopy} options={body} />}
            {bottomCopy && <RichText document={bottomCopy} options={legal} />}
          </TextWrapper>
        )}
        {ctas && <StyledCtas ctas={ctas} direction="row" />}
      </Body>
    </Card>
  );
};

ProductImageCard.propTypes = {
  data: PropTypes.shape(),
  className: PropTypes.string,
};

export default ProductImageCard;
